export const headers = [
  {
    text: "N° de Viaje",
    class: "text-center",
    align: "center clic",
    value: "tripNumber",
    urlFilter: "Offers/GetTripNumbersRequestOffers",
    vmodel: "tripNumber",
    name: "tripNumber",
    showFilter: false,
  },
  {
    text: "Ciudad de Origen",
    class: "text-center",
    align: "center clic",
    value: "originCity",
    urlFilter: "Offers/GetOriginCityOffers",
    vmodel: "originCity",
    name: "originCity",
    showFilter: false,
  },
  {
    text: "Dirección de Origen",
    class: "text-center",
    align: "center clic",
    value: "originAddress",
    urlFilter: "Offers/GetOrginAddresRequestOffers",
    vmodel: "originAddress",
    name: "originAddress",
    showFilter: false,
  },
  {
    text: "Ciudad de Destino",
    class: "text-center",
    align: "center clic",
    value: "destinyCity",
    urlFilter: "Offers/GetDestinyCityRequestOffers",
    vmodel: "destinyCity",
    name: "destinyCity",
    showFilter: false,
  },
  {
    text: "Dirección de Destino",
    class: "text-center",
    align: "center clic",
    value: "destinyAddress",
    urlFilter: "Offers/GetDestinyAddressRequestOffers",
    vmodel: "destinyAddress",
    name: "destinyAddress",
    showFilter: false,
  },
  {
    text: "Transportista",
    class: "text-center",
    align: "center clic",
    value: "transporter",
    urlFilter: "Offers/GetTransporterNameRequestOffers",
    vmodel: "transporter",
    name: "transporter",
    showFilter: false,
  },
  {
    text: "Estado de Oferta",
    class: "text-center",
    value: "offerStatus",
    width: "10%",
    align: "clic",
    urlFilter: "Offers/GetStatusRequestOffers",
    vmodel: "offerStatus",
    name: "state",
    showFilter: false,
  },
  {
    text: "Location Seller",
    class: "text-center",
    value: "locationSeller",
    width: "10%",
    align: "clic",
    urlFilter: "Offers/GetNameLocationSellerRequestOffers",
    vmodel: "locationSeller",
    name: "locationSeller",
    showFilter: false,
  },
  {
    text: "Business Unit",
    class: "text-center",
    value: "businessUnit",
    width: "10%",
    align: "clic",
    urlFilter: "Offers/GetBusinessUnitRequestOffers",
    vmodel: "businessUnit",
    name: "businessUnit",
    showFilter: false,
  },

  {
    text: "Travel State",
    class: "text-center",
    value: "travelState",
    width: "10%",
    align: "clic",
    urlFilter: "Offers/GetTravelStateRequestOffers",
    vmodel: "travelState",
    name: "travelState",
    showFilter: false,
  },
  {
    text: "Fecha y Hora de Creación",
    class: "text-center",
    align: "center clic",
    value: "createdOn",
    urlFilter: "Offers/GetCreateOnRequestOffers",
    vmodel: "createdOn",
    name: "createdOn",
    showFilter: false,
  },
  {
    text: "Fecha y Hora de Confirmación",
    class: "text-center",
    align: "center clic",
    value: "updateOn",
    urlFilter: "",
    vmodel: "updateOn",
    name: "updateOn",
    showFilter: false,
  },
];
